module.exports = __webpack_public_path__ + "img/line.dfef77f2.svg";